import React from 'react'
import {config} from '../../../config'
import {getItem} from '../../../common/utils'
import {findCompany, getCurrentTheme} from '../../../common/utils/general'

export type Account = {
  id: number
}

// @todo this AppContext not actually being used, but it references the type
const AppContext = React.createContext({
  company: config.key,
  companyObject: findCompany(),
  locale: getItem('locale', 'en') as string,
  showNotification: (data: any) => {},
  themePreference: getCurrentTheme() as any,
  toggleTheme: (x,y) => {}
})

export default AppContext
